<template>
    <page>
        <module :title="id ? '编辑限时折扣活动' : '新建限时折扣活动'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="input" label="活动名称" name="activity_name"  maxlength="20" required></c-form-item>
                    <c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
                    <c-form-item type="radio" label="活动预告设置" value="-1"  name="activity_notice" v-model="activityNotice" :options="activityNoticeOptions" required word="活动预告期间，商品详情页价格上方将会展示活动标题，开始时间和折扣力度。" ></c-form-item>
                    <c-form-item type="number" v-if="activityNotice == 1" decimal="1" :limit="[0.1,9999]" v-model="activityNoticeTime"  name="activity_notice_time" word="小时"></c-form-item>
                    <c-form-item type="input" label="活动标签" name="tags"  maxlength="4" placeholder="活动标签名称"></c-form-item>
                    <c-form-item v-if="systemConfig.product_custom == 'ON'" type="radio" label="支持定制" name="is_custom" v-model="isCustom" :options="isCustomOptions" required word="支持定制，则表示定制下单可以享受活动折扣" ></c-form-item>
                    <c-form-item type="textarea" label="活动说明" name="activity_remark"></c-form-item>
                </c-form>

                <c-form title="活动商品">
<!--                    <c-form-item type="select"  :options="productShowTypeMap" label="商品展示形式" name="product_show_type" required></c-form-item>-->
                    <c-form-item type="radio" v-model="commodityRange" label="商品参与方式" name="commodity_range" :options="commodityRangeOption"  :inline-word="false"></c-form-item>
                    <c-form-item v-show="commodityRange == 1">
                        <m-operate class="flex-center-cross">
                          <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
<!--                            <c-radio-group v-model="setConfigType" >
                                <c-radio v-for="(item, i) in setConfigOption" :key="i" :value="item.value">{{item.name}}</c-radio>
                            </c-radio-group>-->
                        </m-operate>

                        <c-table ref="productList" v-model="productList" height="500" :paging="false" border>
                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="200"
                            >
                                <template v-slot="{data}">
                                    <div class="flex-center">
                                        <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
                                    </div>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="商品货号"
                                    name="product_itemnumber"
                            ></c-table-column>

                            <c-table-column
                                    label="价格"
                                    name="product_price"
                                    width="140"
                            >
                                <template v-slot="{data}">
                                  ￥{{data.product_price_min}}
                                  <span v-if="data.product_price_max"> - ￥{{data.product_price_max}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="折扣"
                                    width="100"
                            >
                                <template v-slot="{data}">
                                    <c-input decimal="1" :limit="[0.1,9.9]" v-model="data.activity_discount" width="80" type="number" style="margin: 0 5px;" word="折"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="促销价"
                                    name="promotion_price"
                                    width="140"
                            >
                                <template v-slot="{data}">
                                    <c-input v-if="setConfigType == 2" decimal="2"  v-model="data.promotion_price" width="80" type="number" style="margin: 0 5px;" ></c-input>
                                    <span v-if="setConfigType == 1 && data.activity_discount == 0">0</span>
                                    <span v-if="setConfigType == 1 && data.activity_discount" >
                                      ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
                                      <span v-if="data.product_price_max">
                                          - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
                                      </span>
                                    </span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                            >
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>

                    <c-form-item v-show="commodityRange == 2">
                        <m-operate>
                            <c-button color="gray" hollow @click="$refs.brandSelector.open()">添加品牌</c-button>
                        </m-operate>

                        <c-table ref="brandList" v-model="brandList" height="500" :paging="false" border>
                            <c-table-column
                                    label="品牌名称"
                                    name="brand_name"
                                    width="200"
                            ></c-table-column>

                            <c-table-column
                                    required
                                    label="折扣"
                                    width="100"
                            >
                                <template v-slot="{data}">
                                    <c-input decimal="1" :limit="[0.1,10]" v-model="data.activity_discount" width="80" type="number" style="margin: 0 5px;" word="折"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                            >
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>

                </c-form>
            </c-form>
            <template slot="button">
                <c-button size="m" @click="submit(1)">确定提交</c-button>
            </template>
        </module>

        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
        <brand-selector ref="brandSelector" multiple @resolve="selectHandle($event, 'brandList', 'id')"></brand-selector>

    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    import brandSelector from '@/components/service/brand_selector.vue'
    import {mapState} from "vuex";

    export default {
        name: 'limit_time_discount_edit',

        components: {
            productSelector,brandSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                commodityRange:1,
                setConfigType:1,
                commodityRangeOption: [
                    {name: '指定商品',value: 1},
                    {name: '指定品牌',value: 2}
                ],
                setConfigOption: [
                    {name: '设置折扣',value: 1},
                    {name: '设置促销价',value: 2}
                ],
                productShowTypeMap:[
                    {name:'列表模式',value:'1'},
                    {name:'大图模式',value: '2'}
                ],
                productList: [],
                brandList: [],
                activityNoticeTime: 0,
                activityNotice: 0,
                activityNoticeOptions: [{
                  name: '立即预告',
                  value: 0
                },{
                  name: '不预告',
                  value: -1
                },{
                  name: '提前预告',
                  value: 1
                }],
                isCustom:0, /**定制下单是否享受活动价 0：不享受 1：享受*/
                isCustomOptions:[{
                  name: '不支持',
                  value: 0
               },{
                  name: '支持',
                  value: 1
               }]
            }
        },
	    computed: {
		    ...mapState(['systemConfig'])
	    },
        watch: {
            id() {
                this.getActivityDetail();
            },
            setConfigType(val){
                if(val == 2){
                    this.productList.forEach(item=>{
                        item.activity_discount = '';
                    })
                }else if(val == 1){
                    this.productList.forEach(item=>{
                        item.promotion_price = '';
                    })
                }

            },


        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activitySale/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        this.productList = data.product_list || [];
                        this.brandList = data.brand_list || [];
                        this.commodityRange = data.commodityRange||1;
                        this.setConfigType = data.set_config_type||1;
                        this.activityNoticeTime = data.activity_notice_time;
                    }
                });
            },
            productSelectHandle(list) {
              list = list.filter(item => {
                return !this.productList.find(row => {
                  return row.product_id == item.product_id;
                });
              });
              this.productList = this.productList.concat(list);
            },
            selectHandle(list, ref, key) {
                list = list.filter(item => {
                    return !this[ref].find(row => {
                        return row[key] == item[key];
                    });
                });
                this[ref] = this[ref].concat(list);
            },



            submit(state) {
                this.$refs.form.submit({
                    url: this.id ? '/activitySale/edit' : '/activitySale/add',

                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
                        product_list: [{
                            type: 'function',
                            fun: () => {
                                if(this.commodityRange == 1){
                                    return this.productList.length;
                                }else return true
                            },
                            word: '请选择活动商品'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                                //指定商品且设置折扣时判断
                                if(this.commodityRange == 1 && this.setConfigType == 1){
                                    return !this.productList.find(item => {
                                        return !item.activity_discount;
                                    });
                                }else return true;
                            },
                            word: '请设置活动商品折扣'
                        }],
                        product_config2: [{
                            type: 'function',
                            fun: () => {
                                //指定商品且设置折扣时判断
                                if(this.commodityRange == 1 && this.setConfigType == 2){
                                    return !this.productList.find(item => {
                                        return !item.promotion_price;
                                    });
                                }else return true;
                            },
                            word: '请设置活动商品促销价'
                        }],
                        brand_list: [{
                            type: 'function',
                            fun: () => {
                                if(this.commodityRange == 2){
                                    return this.brandList.length;
                                }else return true
                            },
                            word: '请选择活动品牌'
                        }],
                        brand_config: [{
                            type: 'function',
                            fun: () => {
                                if(this.commodityRange == 2){
                                    return !this.brandList.find(item => {
                                        return !item.activity_discount;
                                    });
                                }else return true;
                            },
                            word: '请设置活动品牌折扣'
                        }]

                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        data.set_config_type = this.setConfigType;
                        data.product_list = this.productList ? Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                product_sku: item.product_sku,
                                activity_discount: parseFloat(item.activity_discount),
                                promotion_price: parseFloat(item.promotion_price),

                            }
                        }):[];
                        data.brand_list =this.brandList ? Array.from(this.brandList, item => {
                            return {
                                brand_id: item.id,
                                activity_discount: item.activity_discount,
                            }
                        }):[];
                        return data;
                    },

                    success: (data,obj) => {
                        // if(obj != null && obj.length !=0){
                        //     var res = "【";
                        //     obj.forEach(item=>{
                        //         res+=item+","
                        //     })
                        //     res = res.substring(0,res.length-1);
                        //     res+="】"
                        //
                        //     this.$message({
                        //         text: '保存成功,存在以下商品和其他活动时间冲突未能添加成功'+res.toString(),
                        //     });
                        // }else{
                        //     this.$message({
                        //         text: "保存成功",
                        //     });
                        // }
                        this.$message({
                            text: '保存成功'
                        });
                        this.$bus.$emit('limitTimeDiscountList.update');
                        this.redirectTo('/limit_time_discount');
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>